module.exports = __webpack_public_path__ + "static/logo-4e9485935fa1550f24ff95e28541fbe3.png";